import { DASHBOARD_BY_ID_PATH, DASHBOARD_EMBED_PAGE } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const dashboardEmbedRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	embed: true,
	name: DASHBOARD_EMBED_PAGE,
	path: `${DASHBOARD_BY_ID_PATH}/:dashboardId/:mode?`,
	query: ['embed=true'],
});
